import { render, staticRenderFns } from "./foldout-card.vue?vue&type=template&id=d335426a&"
import script from "./foldout-card.vue?vue&type=script&lang=ts&"
export * from "./foldout-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports